<div class="page-container content-w-98" [formGroup]="eolFormGroup">
  <div class="page-head">
    <div>
      <div class="page-title">
        <span class="headerName">End-of-life</span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showIncorrectEOLNotification">
    <piqet-angular-incorrect-data-notification
      [message]="incorrectValueMessage"
      [buttonName]="incorrectBtnName"
      (eolAction)="updateIncorrectEolData()"
    ></piqet-angular-incorrect-data-notification>
  </ng-container>

  <div class="EOL-Content-Div" [ngClass]="{ 'disabled-project': isProjectLocked }">
    <!-- Pre retail -->
    <div class="panel-group">
      <div class="accordion">
        <div class="panel panel-default retailEOLPanel">
          <ngb-accordion [closeOthers]="true" activeIds="" class="defaultClass eol-acc-item">
            <ngb-panel id="panel1" cardClass="open">
              <ng-template ngbPanelTitle>
                <div class="sub-title retail-header">
                  <h4
                    text="Expand to view material end-of-life fates for each material."
                    (next)="onNext()"
                    [joyrideStep]="'step27'"
                    [stepPosition]="'bottom'"
                  >
                    Retail End-of-life
                  </h4>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div>
                  <div class="info-padding" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div>
                      <p id="eol-info-text">
                        Waste from pallet, traded and merchandizing packaging levels
                        <a
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          class="question"
                          ngbTooltip="Model the end-of-life of the waste generated from the wholesale stage through to the point of retail."
                        >
                          <img
                            src="./assets/icons/grey-question-icon.svg"
                            width="17"
                            height="16"
                            alt=""
                          />
                        </a>
                      </p>
                    </div>
                  </div>

                  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div class="custom-drpdown-width">
                      <label
                        *ngIf="eolFormGroup.get('country')?.value"
                        class="sub-header-drpdown pb-2"
                        >Where is the end-of-life region?</label
                      >
                      <ng-select
                        [clearable]="false"
                        #country
                        [items]="retailCountryList"
                        [searchable]="false"
                        bindLabel="name"
                        formControlName="country"
                        bindValue="id"
                        (change)="changeCountry($event)"
                        placeholder="Where is the end-of-life region?"
                        [readonly]="isCustomRetailEol"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              class="form-control accordion-search search-input"
                              id="inputValidation"
                              placeholder="Search..."
                              (input)="country.filter($any($event.target).value)"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>

                  <!-- Retail EOL -->
                  <ng-container
                    *ngTemplateOutlet="eolTemplate; context: { type: retailType }"
                  ></ng-container>
                  <div
                    class="countryNotification settMarginWaste mt-4"
                    *ngIf="isShowRetailNotification"
                    [ngClass]="{ 'disabled-popup': !showEdit }"
                  >
                    <span>{{ endOfLifeRegionMessage }}</span>
                  </div>
                  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div class="col-6 material-spacing">
                      <p id="eol-info-text">{{ reportResource.lblEolFates }}</p>
                    </div>
                  </div>

                  <div>
                    <div>
                      <div class="row" *ngrxLet="projectFacade.packageEOLRetail$ as packRetailList">
                        <div
                          class="col-md-12"
                          *ngrxLet="{
                            dataLoaded: (sharedFacade.isLoaded$ | async),
                            isClearSearch: (sharedFacade.isClearSearch$ | async)
                          } as sharedData"
                        >
                          <piqet-angular-portlet
                            [columnDefs]="columnDefsRetail"
                            [frameworkComponents]="frameworkComponents"
                            [gridData]="packRetailList"
                            [hideSearch]="true"
                            [hidePagination]="true"
                            [class]="'scrollGrid'"
                            [isClearSearch]="sharedData.isClearSearch"
                            [isEOLGrid]="true"
                            [gridName]="'Retail'"
                          ></piqet-angular-portlet>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div class="col-6 material-spacing d-flex">
                      <p id="eol-info-text">Component specific end-of-life settings</p>
                      <span
                        class="question custom"
                        placement="auto"
                        tooltipClass="sku-tooltip"
                        ngbTooltip="Advanced end-of-life fate to override default fate"
                        ><img
                          src="./assets/icons/grey-question-icon.svg"
                          width="17"
                          height="16"
                          alt=""
                      /></span>
                    </div>
                  </div>

                  <div [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div>
                      <div class="row">
                        <div
                          class="col-md-12"
                          *ngrxLet="{
                            dataLoaded: (sharedFacade.isLoaded$ | async),
                            isClearSearch: (sharedFacade.isClearSearch$ | async)
                          } as sharedData"
                        >
                          <piqet-angular-portlet
                            [columnDefs]="colDefsCustomFate"
                            [frameworkComponents]="frameworkComponents"
                            [gridData]="recycledContentGridData"
                            [hideSearch]="true"
                            [hidePagination]="true"
                            [isClearSearch]="sharedData.isClearSearch"
                            [isEOLGrid]="true"
                          ></piqet-angular-portlet>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
    </div>

    <!-- Post retail -->

    <div class="panel-group">
      <div class="accordion">
        <div class="panel panel-default">
          <ngb-accordion [closeOthers]="true" activeIds="[]" class="defaultClass eol-acc-item">
            <ngb-panel id="panel1" cardClass="open">
              <ng-template ngbPanelTitle>
                <div class="sub-title retail-header">
                  <h4>Consumer End-of-life</h4>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div>
                  <div class="info-padding" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div>
                      <p id="eol-info-text">
                        Waste from retail and sub-retail packaging levels
                        <a
                          class="question"
                          placement="auto"
                          tooltipClass="sku-tooltip"
                          ngbTooltip="Model the end-of-life of the waste generated from the retail stage, through to consumer usage and eventual disposal."
                        >
                          <img
                            src="./assets/icons/grey-question-icon.svg"
                            width="17"
                            height="16"
                            alt=""
                          />
                        </a>
                      </p>
                    </div>
                  </div>

                  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div class="custom-drpdown-width">
                      <label
                        *ngIf="eolFormGroup.get('countryConsumer')?.value"
                        class="sub-header-drpdown pb-2"
                        >Where is the end-of-life region?</label
                      >
                      <ng-select
                        [clearable]="false"
                        #countryConsumer
                        [items]="consumerCountryList"
                        [searchable]="false"
                        bindLabel="name"
                        formControlName="countryConsumer"
                        bindValue="id"
                        placeholder="Where is the end-of-life region?"
                        (change)="changeCountryConsumer($event)"
                        [readonly]="isCustomConsumerEol"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              type="text"
                              class="form-control accordion-search search-input"
                              id="inputValidation"
                              placeholder="Search..."
                              (input)="countryConsumer.filter($any($event.target).value)"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                            {{ item.name }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>

                  <!-- Consumer EOL -->
                  <ng-container
                    *ngTemplateOutlet="
                      eolTemplate;
                      context: {
                        type: 'consumer'
                      }
                    "
                  ></ng-container>
                  <div
                    class="countryNotification settMarginWaste mt-4"
                    *ngIf="isShowConsumerNotification"
                  >
                    <span>{{ endOfLifeRegionMessage }}</span>
                  </div>
                  <div class="row">
                    <div class="col-6 material-spacing">
                      <p id="eol-info-text">{{ reportResource.lblEolFates }}</p>
                    </div>
                  </div>

                  <div>
                    <div>
                      <div
                        class="row"
                        *ngrxLet="projectFacade.packageEOLConsumer$ as packageEOLConsumer"
                      >
                        <div
                          class="col-md-12"
                          *ngrxLet="{
                            dataLoaded: (sharedFacade.isLoaded$ | async),
                            isClearSearch: (sharedFacade.isClearSearch$ | async)
                          } as sharedData"
                        >
                          <piqet-angular-portlet
                            [columnDefs]="columnDefsConsumer"
                            [frameworkComponents]="frameworkComponents"
                            [gridData]="packageEOLConsumer"
                            [hideSearch]="true"
                            [hidePagination]="true"
                            [headerBtnName]="'preRetailEOL'"
                            [isClearSearch]="sharedData.isClearSearch"
                            [class]="'scrollGrid'"
                            [isEOLGrid]="true"
                            [gridName]="'Consumer'"
                          ></piqet-angular-portlet>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div class="col-6 material-spacing d-flex">
                      <p id="eol-info-text">Component specific end-of-life settings</p>
                      <span
                        class="question custom"
                        placement="auto"
                        tooltipClass="sku-tooltip"
                        ngbTooltip="Advanced end-of-life fate to override default fate"
                        ><img
                          src="./assets/icons/grey-question-icon.svg"
                          width="17"
                          height="16"
                          alt=""
                      /></span>
                    </div>
                  </div>

                  <div [ngClass]="{ 'disabled-popup': !showEdit }">
                    <div>
                      <div class="row">
                        <div
                          class="col-md-12"
                          *ngrxLet="{
                            dataLoaded: (sharedFacade.isLoaded$ | async),
                            isClearSearch: (sharedFacade.isClearSearch$ | async)
                          } as sharedData"
                        >
                          <piqet-angular-portlet
                            [columnDefs]="colDefsCustomFate"
                            [frameworkComponents]="frameworkComponents"
                            [gridData]="recycledContentGridConsumer"
                            [hideSearch]="true"
                            [hidePagination]="true"
                            [isClearSearch]="sharedData.isClearSearch"
                            [isEOLGrid]="true"
                          ></piqet-angular-portlet>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
    </div>

    <!-- reuse -->
    <div class="panel-group">
      <div class="accordion">
        <div class="panel panel-default">
          <ngb-accordion
            [closeOthers]="true"
            [activeIds]="joyrideService.isTourInProgress() ? 'panel1' : ''"
            class="defaultClass eol-acc-item"
          >
            <ngb-panel id="panel1" cardClass="open">
              <ng-template ngbPanelTitle>
                <div class="sub-title retail-header">
                  <h4>Reuse</h4>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="sub-title Custom-margin-reuse">
                  <h4>Reuse of components</h4>
                </div>

                <div class="row">
                  <div class="col-6">
                    <p id="inner-eol-info-text">Components that can be reused</p>
                  </div>
                </div>

                <div>
                  <div>
                    <div class="row">
                      <div
                        class="col-md-12"
                        *ngrxLet="{
                          dataLoaded: (sharedFacade.isLoaded$ | async),
                          isClearSearch: (sharedFacade.isClearSearch$ | async)
                        } as sharedData"
                      >
                        <piqet-angular-portlet
                          [columnDefs]="columnDefsPreretail"
                          [class]="'overflowCheck'"
                          [frameworkComponents]="frameworkComponents"
                          [headerBtn]="'Add data'"
                          [searchInputSize]="true"
                          [gridData]="preRetailData"
                          [hideSearch]="true"
                          [hidePagination]="true"
                          [stepCount]="'step26'"
                          (openBtnModal)="addPreRetail([], 0, 'Add reuse data', 'preRetail')"
                          [stepPos]="'top'"
                          [stepText]="eolGTStepStr"
                          [isClearSearch]="sharedData.isClearSearch"
                          [pageNo]="$any(preRetailData)?.draw"
                          [createAccess]="showEdit"
                          [gridName]="'Add project eol reatil '"
                        ></piqet-angular-portlet>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
    </div>
  </div>

  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>

<ng-template
  #eolTemplate
  let-isCustomEol="isCustomEol"
  let-customEolList="customEolList"
  let-type="type"
>
  <div class="row mt-5" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="col-md-6" [piqetAngularSectionAccess]="FeatureCodes.EOL_CUSTOM_END_OF_LIFE">
      <div class="d-flex checkBoxAlienMent">
        <div>
          <input
            type="checkbox"
            [ngModelOptions]="{ standalone: true }"
            class="chkOverview"
            [ngModel]="getCustomEolValue(type)"
            (change)="changEolValue($event, type)"
          />
        </div>
        <div>
          <span class="checkbox-style">Custom end of life</span>
        </div>
      </div>
    </div>
    <div class="col-md-6" [piqetAngularSectionAccess]="FeatureCodes.EOL_CUSTOM_END_OF_LIFE">
      <div class="d-flex justify-content-end">
        <div></div>
        <div
          class="mb-3 d-flex justify-content-end align-items-center"
          *ngIf="showEdit && showCustomWasteAccess"
        >
          <a class="add-link" target="_blank" routerLink="/custom/wasteScenarios">
            <span class="redirectLinkText">Add custom end of life</span>
          </a>
          <a
            class="setLinkIconPosition"
            target="_blank"
            replaceUrl="true"
            routerLink="/custom/wasteScenarios"
          >
            <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
          </a>
          <span class="setLinkIconPosition" (click)="refreshCustomWasteScenario(type)">
            <img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13" />
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="getCustomEolValue(type)" [ngClass]="{ 'disabled-popup': !showEdit }">
    <div class="custom-drpdown-width">
      <label class="sub-header-drpdown pb-2">Select custom end-of-life</label>
      <ng-select
        [clearable]="false"
        #eolSelect
        [items]="getCustomEolList(type)"
        [searchable]="false"
        bindLabel="name"
        bindValue="wasteScenarioId"
        (change)="changeEolRetail($event, type)"
        [ngModel]="getCustomEolSelectedId(type) || null"
        placeholder="Select custom end-of-life"
      >
        <ng-template ng-header-tmp>
          <div class="has-feedback">
            <input
              type="text"
              class="form-control accordion-search search-input"
              id="inputValidation"
              placeholder="Search..."
              (input)="eolSelect.filter($any($event.target).value)"
            />
            <span class="form-control-feedback">
              <i class="fa fa-search icon"></i>
            </span>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
          <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>
</ng-template>
